angular.module('lf.common')

.controller('SubscriptionCancelMembershipCtrl', function ($scope, $injector, subscriptionService) {
  var client = lf.data.xhr.client;
  
  $scope.error = null;
  
  $scope.cancelMembership = function cancelMembership () {
    $scope.processing = true;
    $scope.showProcessingPopup();
    $scope.error = null;
    
    subscriptionService.cancelMembership()
      .success(function (data) {
        if (data.success) {
          $scope.closeModal();
          window.location.reload();
        } else {
          $scope.error = {};
          if (data && data.error && data.error.details) {
            $scope.error.message = data.error.details[0];
          } else {
            $scope.error.serverError = true;
          }
          $scope.processing = false;
          $scope.hideProcessingPopup();
        }
      })
      .error(function (error) {
        $scope.error = { serverError: true };
        $scope.processing = false;
        $scope.hideProcessingPopup();
      });
  }
  
  $scope.closeModal = function () {
    var isDesktop = client.isDesktop || client.isLFC;
    var modal = $injector.get(isDesktop ? 'popupsService' : 'slideinService');
    modal.hide('cancel-membership');
  }
});
